import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import TextNavTitle from '../../components/TextNavTitle'
import CardCustom from '../../components/custom/card-custom'
import NavRoleOrg from '../../components/nav-role-org'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import imgUser from '../../images/user.png'
import {
  createPropertyAssetAPI,
  getDetailAssetITAPI,
  getPropertyAssetAPI
} from '../../services/property'
import { useSelector } from 'react-redux'
import SwalCustom from '../../alert/swal-custom'
import Error_false from '../../components/error/error-false'
import Error_500 from '../../components/error/error-500'
import moment from 'moment'
import Autocomplete from '../../components/custom/autocomplete'
import { Input } from 'antd'
import UseEmpsUserAsset from '../../hooks/use-detail-search'
import { BsPlusLg } from 'react-icons/bs'
import UseEmpsUserAssetIT from '../../hooks/use-detail-search-asset-it'
import useNumberInput from '../../helper/input-fix-num'
import Swal from 'sweetalert2'
const schema = yup
  .object({
    assetId: yup.string().required('Please, Fill assetID'),
    detail: yup.string().required('Please, Fill detail')
  })
  .required()

export default function AssetITPage() {
  // const orgId = useSelector((state) => state.roleReducer.role)
  const [add, setAdd] = useState(false)
  const [detail, setDetail] = useState()
  const [isSave, setIsSave] = useState(false)
  const [assetId, setAssetId] = useState()
  const [dataTable, setdataTable] = useState([])
  const [opSearch, setOpSearch] = useState()
  const [newOrgId, setNewOrgId] = useState()
  const optionSearch = UseEmpsUserAssetIT(opSearch)

  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    setDetail('')
    setdataTable('')
    setOpSearch(null)
    setAdd(false)
    setAssetId(null)
  }, [])

  useEffect(() => {
    const getDetailAssets = async () => {
      const result = await getDetailAssetITAPI({
        uuid: opSearch?.uuid ?? ''
      })
      if (!result) return
      if (result.status) {
        setDetail(result.result)
      }
    }
    if (opSearch) {
      if (opSearch?.orgId) {
        setNewOrgId(opSearch?.orgId)
      }
      getDetailAssets()
    }
  }, [opSearch])

  useEffect(() => {
    const getAssets = async () => {
      const body = {
        orgId: newOrgId ?? opSearch?.orgId ?? '',
        code: detail?.code
      }
      const result = await getPropertyAssetAPI(body)
      if (!result) return
      if (result.status) {
        setdataTable(result.result)
        setAdd(true)
      }
    }
    getAssets()
  }, [detail, isSave])

  const {
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const onSubmit = () => {
    const parsedAssetId = parseInt(assetId)

    const body = { orgId: newOrgId, code: detail?.code, assetId: parsedAssetId }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create Asset new?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createAssetsTable(body)
      }
    })
  }

  const createAssetsTable = async (body) => {
    try {
      const data = await createPropertyAssetAPI(body)

      if (data?.status) {
        SwalCustom({
          icon: 'success',
          title: 'Your asset has been saved',
          showConfirmButton: false,
          timer: 1500
        })
        setIsSave(true)
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Please fill information or check your asset number again',
          showConfirmButton: false,
          timer: 3000
        })
        // Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Setting Asset IT</TextNavTitle>
      </NavTitle>

      <Col xl={12}>
        {/* <NavRoleOrg /> */}

        <CardCustom border="0" className="h-full mt-2">
          <div className="p-3 row">
            <div className="col-5">
              <h4 className="text-muted mb-0" style={{ float: 'left' }}>
                Asset IT
              </h4>
            </div>
            <div className="d-flex justify-content-end col-7">
              <span className="me-2 col-6">
                <Autocomplete
                  className="border-end-0"
                  placeholder="Org/ Code/ Username"
                  options={optionSearch}
                  value={opSearch}
                  onChange={(data) => setOpSearch(data)}
                  onInputChange={(data) => setOpSearch(data)}
                />
              </span>
            </div>
          </div>
          <div className="p-3">
            <Form
              onSubmit={handleSubmit(onSubmit)}
              className="mt-3 row"
              style={{ rowGap: '5px' }}
            >
              <Col xl={12}>
                {' '}
                <Row
                  style={{
                    paddingBottom: '20px',
                    borderBottom: '0.2px solid grey'
                  }}
                >
                  <Col xl={2}>
                    <div className="d-flex align-items-middle justify-content-center mt-2">
                      <Image
                        src={detail?.img_url ?? imgUser}
                        style={{ width: '70px', borderRadius: '50%' }}
                      />
                    </div>
                  </Col>
                  <Col xl={3}>
                    <div className="mt-3">
                      <div className="d-flex  justify-content-start small">
                        <p>Name: {detail?.name_en ?? '-'}</p>
                      </div>
                      <div className="small">
                        <p>Code: {detail?.code ?? '-'}</p>
                      </div>
                    </div>
                  </Col>
                  <Col xl={3}>
                    <div className="mt-3">
                      <div className="d-flex align-items-middle justify-content-start small">
                        <p>Department: {detail?.division_en ?? '-'}</p>
                      </div>
                      <div className="small">
                        <p>Position: {detail?.position_en ?? '-'}</p>
                      </div>
                    </div>
                  </Col>
                  <Col xl={3}>
                    <div className="mt-3">
                      <div className="d-flex justify-content-start small">
                        <p>Type: {detail?.type ?? '-'}</p>
                      </div>
                      <div className="small">
                        <p>Email: {detail?.email ?? '-'}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-1 p-4">
                  <div className="col-5"></div>

                  <div className="col-7">
                    <span className="d-flex justify-content-end gap-2">
                      <Form.Control
                        className="w-50"
                        onChange={(e) => {
                          setAssetId(e.target.value)
                        }}
                        style={{
                          height: '32px'
                        }}
                        onKeyDown={handleKeyDownNum}
                      />
                      <Button
                        className="w-25 mb-1 "
                        size="sm"
                        onClick={() => {
                          onSubmit()
                        }}
                      >
                        <BsPlusLg /> Add
                      </Button>
                    </span>
                  </div>

                  {add ? (
                    <>
                      <div className="d-flex mt-4 mb-3">Detail:</div>
                      <div className="d-flex gap-2">
                        <Table>
                          <thead>
                            <tr className="fw-normal">
                              <th>#</th>
                              <th>Category</th>
                              <th>Tag</th>
                              <th>Insert Date</th>
                              <th>Update Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataTable.length > 0 ? (
                              dataTable.map((d, i) => (
                                <tr className="small">
                                  <td>{i + 1}</td>
                                  <td>{d?.category}</td>
                                  <td>{d?.asset_tag}</td>
                                  <td>
                                    {moment(d?.insert_date).format(
                                      'DD/MM/YYYY'
                                    )}
                                  </td>
                                  <td>
                                    {moment(d?.update_date).format(
                                      'DD/MM/YYYY'
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center" colSpan={5}>
                                  -No Data-
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </Row>
              </Col>
            </Form>
          </div>
        </CardCustom>
      </Col>
    </Row>
  )
}
